import React, { useEffect, useState } from 'react';
import Sidebar from "../Side/Sidebar";
import Topbar from "../Side/Topbar";
import AOS from 'aos';
import 'aos/dist/aos.css';
import AddQATicketModelForm from "../QATicket/AddQATicketModelForm";
import QATicketTable from "../QATicket/QATicketTable";
import { useAuth } from "../Auth/AuthContext"; // Import useAuth
import AdminSidebar from "../Side/AdminSidebar";

const QATicket = () => {
    const [tickets, setTickets] = useState([]);
    const [openModal, setOpenModal] = useState(false); // State to control modal open/close
    const { authState } = useAuth(); // Get authState from AuthContext
    const role = authState.roles;
    const admin = role === "Admin";


    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true,
        });

        // Simulate fetching data
        const timer = setTimeout(() => {
            setTickets([
                { id: 1, title: 'Bug in Login', status: 'Open', details: 'details 1', createdAt: '2024-10-16' },
                { id: 2, title: 'UI Issue on Home Page', status: 'In Progress', details: 'details 2', createdAt: '2024-10-15' },
                { id: 3, title: 'API Response Error', status: 'Closed', details: 'details 3', createdAt: '2024-10-10' },
            ]);
        }, 1000);

    }, []);

    const handleCreateNewTicket = () => {
        // Logic to create a new QA ticket goes here

        setOpenModal(false); // Close the modal after creating the ticket
    };

    return (
        <div className="mt-6">
            {/* Button to Open Modal */}
            <button
                onClick={() => setOpenModal(true)} // Open the modal
                className="mb-4 px-4 py-2 bg-primaryColor text-white rounded-md"
            >
                Create New QA Ticket
            </button>

            <QATicketTable />
            {/* Modal Popup */}
            <AddQATicketModelForm isOpen={openModal} closeModal={() => setOpenModal(false)} />
        </div>
    );
};

export default QATicket;
